import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PerInfoBoxTrueFalseElement } from '../../../../components/custom_components/InfoBox/InfoBoxTrueFalseElement'
import useCompanyRankingSettingsMutations from '../../../../graphql/company-ranking-settings/hooks/useCompanyRankingSettingsMutations'

import { CompanySettingsRankingsSettingsFormProps } from './CompanySettingsRankingsSettingsForm'
import { useCompanySettingsRankingFormControl } from './useCompanySettingsRankingFormControl'

export const CompanySettingsRankingAllowContractChangesControl: FC<CompanySettingsRankingsSettingsFormProps> = ({
  companyId,
  country,
  settings,
  disabled,
}) => {
  const { t } = useTranslation()

  const { updateLowPercentageIsBlocker } = useCompanyRankingSettingsMutations(companyId, country)

  const [formValue, setFormValue] = useCompanySettingsRankingFormControl<boolean>(
    settings.lowPercentageIsBlocker,
    updateLowPercentageIsBlocker,
  )

  return (
    <PerInfoBoxTrueFalseElement
      label={t('companySettingsView.rankingTab.settings.allowContractChanges')}
      onValueChanged={(val) => setFormValue(!val)}
      currentValue={!formValue}
      disabled={disabled}
    />
  )
}
